module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAqBAMAAAD8NjCWAAAAElBMVEUAAAD4aGj4aWn4aGj3aWn4aWm/gw+TAAAABXRSTlMA8r1MheKcwngAAABFSURBVDjLY2AwEg3FBwKVGRhYQgkBBwZTgmqCGVQJqgliECWoJpAhlDAYVTOqZlTNqBpaqCGmjCKmrCOmzCSm7CWmDAcARa7joj2gQPIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_icon.png
// module id = 3k+E
// module chunks = 167